import React from 'react';

export const whatWeOffer = [
  {
    text: "END TO END DESIGN SOLUTION",
    image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F1.webp?alt=media&token=dd471068-2dc2-4625-b6b2-f411e98ede52",
  },
  {
    text: "2D WORKING DRAWING",
    image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F1.webp?alt=media&token=dd471068-2dc2-4625-b6b2-f411e98ede52",
  },
  {
    text: "BOQ & COSTING",
    image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F1.webp?alt=media&token=dd471068-2dc2-4625-b6b2-f411e98ede52",
  },
  {
    text: "CUSTOM PRODUCT DESIGN",
    image:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F4.webp?alt=media&token=b8df824f-2096-4c92-9a81-20eb274807c2",
  },
  {
    text: "360 DEGREE VIEW",
    image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F5.webp?alt=media&token=68065d0e-767a-4d2b-8833-ae4b463d0d5a",
  },
  {
    text: "3D RENDERED DESIGN",
    image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Foffers%2Fofferings%2F6.webp?alt=media&token=55739153-58f8-4a8d-8b30-689179c76cbc",
  },
];

const KeyFeatures = () => {
  return (
    <div className="py-10 bg-[#01382A] text-white">
      <h1 className="font-bold md:text-[45px] text-[28px] text-center mb-10 w-fit mx-auto">
        WHAT WE OFFER
      </h1>

      <div className="flex justify-center items-center gap-8 md:flex-row flex-col">
        {whatWeOffer.map((item, index) => (
          <div key={index} className="flex flex-col w-44 h-44 items-center">
            <img
              src={item.image}
              className="h-24 object-contain"
              alt={item.text}
            />
            <h1 className="text-lg py-4 font-semibold text-center">
              {item.text}
            </h1>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyFeatures;
